'use client';
import { useEffect, useState } from 'react';

export interface UseMatchesMediaQueryParams {
  query: string;
}

export const useMatchesMediaQuery = ({
  query,
}: UseMatchesMediaQueryParams): boolean => {
  const [matches, setMatches] = useState(
    typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const mq = window?.matchMedia(query);
    const callback = (e: MediaQueryListEvent) => setMatches(e.matches);

    // Kick a re-render after page load if the media query result
    // doesn't match the server-side user-agent detection.
    setMatches(mq.matches);

    mq.addEventListener('change', callback);

    return () => mq?.removeEventListener('change', callback);
  }, [query]);

  return matches;
};
